import { BaseColumnProps } from "../../types";
import { formatDisplay } from "../formatDisplay";

export function MarketCapColumn({ record }: BaseColumnProps) {
  const marketCapResult = formatDisplay([record.market_cap], "$");
  return (
    <span className="text-content_primary body_medium_m">
      {marketCapResult.unit}
      {marketCapResult.data}
    </span>
  );
}
